import React, { Component } from "react";
import "./PageHead.css";

class PageHead extends Component {
  render() {
    return (
      <div className="page-head-container">
        <div>{this.props.text}</div>
      </div>
    );
  }
}

export default PageHead;
